<template>
    <v-menu offset-y :close-on-content-click="true">
        <template v-slot:activator="{ on }">
            <v-btn text fab v-on="on" color="hubblue">
                <v-avatar color="white">{{ user.firstName.charAt(0) + user.lastName.charAt(0) }}</v-avatar>
            </v-btn>
        </template>
        <v-list flat>
            <v-list-item
                v-for="item in userMenuItems"
                :key="item.title"
                @click.native="item.action"
                style="cursor: pointer"
            >
                <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-action mx-0 v-text="item.title"></v-list-item-action>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    props: ['user', 'userMenuItems']
}
</script>
